module.exports = __webpack_public_path__ + "img/nasa.59112320.png";